<script setup>
    // Minimal layout for pages that must render with zero network access
    // (currently just /offline, the service worker's navigation fallback).
    //
    // The default/iframe/archives layouts all instantiate ~10 Pinia stores and
    // fire off fetches (fetchNotifications, initUserData, fetchSites, etc.) from
    // setup()/onMounted, which fail (or hang, depending on the failure mode)
    // when there's no network — making the offline fallback itself break.
    // This layout intentionally does none of that: no store imports, no
    // useAsyncData/$fetch calls, just the page content and shared styles.
    import { updateHead } from '@/composables/helpers/updateHead';

    // See the note in layouts/sunset.vue: an omitted `image` is an empty
    // og:image, not an inherited one.
    const frontEnd = useRuntimeConfig().public.clientFrontend;

    updateHead({
        title: "Offline | Open House Chicago",
        description: 'You are currently offline.',
        path: useRoute().path,
        image: frontEnd + '/img/ohc-share.jpg',
    });
</script>

<template>
    <div id="main" class="bare-layout">
        <NuxtPage />
    </div>
</template>

<style lang="scss">
    @use '@/assets/styles/main.scss';
</style>
